export default "__VITE_ASSET__D8MILK3L__"